<script>
import { get_role_update_auth_info, update_role_auth_submit } from '@/api/enterprise'
import UmTableRole from '@/components/UmTableRole'
import { mapGetters } from 'vuex'
export default {
  name: 'PlatformAuth',
  components: { UmTableRole }, // 平台权限
  props: {
    roleUuid: {
      type: String,
      default: ''
    },
    roleTypeCode: {
      type: [Number, String],
      default: null
    },
    readOnlyFlag: {
      type: [Boolean, Number],
      default: false
    }
  },
  data() {
    return {
      loading: false,
      roleModuleTree: [],
      checkAllFlag: 0,
      appUuidList: [],
      organUuidList: [],
      roleModuleAuth: []
    }
  },
  computed: {
    ...mapGetters(['roles']),
    disabled() {
      const hasRoles = this.roles.includes('11203040203003')
      return this.loading || !hasRoles || this.roleTypeCode !== 1003502 || Boolean(this.readOnlyFlag) // 角色组类型
    }
  },
  watch: {
    roleUuid: {
      handler(val) {
        if (val) this.getRoleData()
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    async saveRole() {
      const load = this.$load()
      const roleModuleAuth = this.$refs.UmTableRole.getCheckData()
      try {
        this.loading = true
        const res = await update_role_auth_submit({
          roleUuid: this.roleUuid,
          roleOrganAuth: {
            type: 4,
            organUuidList: this.organUuidList
          },
          roleModuleAuth: roleModuleAuth,
          roleAppManageAuth: {
            checkAllFlag: this.checkAllFlag,
            appUuidList: this.appUuidList
          }
        })
        this.$message.success(res.msg)
      } catch (e) {

      } finally {
        load.close()
        this.loading = false
      }
    },
    async getRoleData() {
      try {
        const result = await get_role_update_auth_info({
          roleUuid: this.roleUuid
        })
        this.roleModuleTree = result.data.roleModuleTree
        this.checkAllFlag = result.data.roleAppManageAuth.checkAllFlag
        this.appUuidList = result.data.roleAppManageAuth.appList.filter(i => i.checked).map(i => i.appUuid)
        this.organUuidList = result.data.roleOrganAuth.organUuidList || []
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<template>
  <div class="role-auth">
    <div class="role-options">
      <el-button type="primary" :loading="loading" :disabled="disabled" @click="saveRole">保存</el-button>
    </div>
    <div class="role-table-data">
      <um-table-role ref="UmTableRole" :tree-data="roleModuleTree" :disabled="disabled" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.role-auth{
  position: relative;
  margin-top: 20px;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;

  .role-options{
    position: absolute;
    top: -53px;
    right: 0;
    z-index: 10;
  }
  .role-table-data{
    flex: 1;
    height: 100%;
    overflow: auto;
    padding-bottom: 80px;
  }
}
</style>
